var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pace"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pace_2",
    d: "M7 12.8333C6.19306 12.8333 5.43472 12.6802 4.725 12.374C4.01528 12.0677 3.39792 11.6521 2.87292 11.1271C2.34792 10.6021 1.93229 9.98472 1.62604 9.275C1.31979 8.56528 1.16667 7.80694 1.16667 7C1.16667 6.19306 1.31979 5.43472 1.62604 4.725C1.93229 4.01528 2.34792 3.39792 2.87292 2.87292C3.39792 2.34792 4.01528 1.93229 4.725 1.62604C5.43472 1.31979 6.19306 1.16667 7 1.16667C7.80694 1.16667 8.56528 1.31979 9.275 1.62604C9.98472 1.93229 10.6021 2.34792 11.1271 2.87292C11.6521 3.39792 12.0677 4.01528 12.374 4.725C12.6802 5.43472 12.8333 6.19306 12.8333 7C12.8333 7.2625 12.8188 7.52014 12.7896 7.77292C12.7604 8.02569 12.7118 8.27361 12.6438 8.51667C12.5076 8.36111 12.3497 8.22986 12.1698 8.12292C11.9899 8.01597 11.7931 7.94306 11.5792 7.90417C11.6083 7.75833 11.6302 7.61007 11.6448 7.45938C11.6594 7.30868 11.6667 7.15556 11.6667 7C11.6667 5.69722 11.2146 4.59375 10.3104 3.68958C9.40625 2.78542 8.30278 2.33333 7 2.33333C5.69722 2.33333 4.59375 2.78542 3.68958 3.68958C2.78542 4.59375 2.33333 5.69722 2.33333 7C2.33333 8.30278 2.78542 9.40625 3.68958 10.3104C4.59375 11.2146 5.69722 11.6667 7 11.6667C7.49583 11.6667 7.96979 11.5938 8.42188 11.4479C8.87396 11.3021 9.28958 11.0979 9.66875 10.8354C9.78542 11.0007 9.92882 11.1465 10.099 11.2729C10.2691 11.3993 10.4514 11.4965 10.6458 11.5646C10.15 11.9632 9.5934 12.2743 8.97604 12.4979C8.35868 12.7215 7.7 12.8333 7 12.8333ZM10.7115 10.2885C10.5705 10.1476 10.5 9.975 10.5 9.77083C10.5 9.56667 10.5705 9.3941 10.7115 9.25313C10.8524 9.11215 11.025 9.04167 11.2292 9.04167C11.4333 9.04167 11.6059 9.11215 11.7469 9.25313C11.8878 9.3941 11.9583 9.56667 11.9583 9.77083C11.9583 9.975 11.8878 10.1476 11.7469 10.2885C11.6059 10.4295 11.4333 10.5 11.2292 10.5C11.025 10.5 10.8524 10.4295 10.7115 10.2885ZM8.925 9.74167L6.41667 7.23333V4.08333H7.58333V6.76667L9.74167 8.925L8.925 9.74167Z",
    fill: "#333357"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaceIcon);
export default __webpack_public_path__ + "static/media/PaceIcon.b86ee994f7172635e74ae0f6f11b4991.svg";
export { ForwardRef as ReactComponent };